import axios from "../../lib/apiAxios";

const authAdminPath = "/auth/admin";

async function call(method, path, data) {
    const response = await axios[method](`${authAdminPath}${path}`, data);
    return response.data;
}

export function buildAdminAPI(basePath) {
    return {
        get: (path) => {
            return call("get", basePath + path);
        },
        put: (path, data) => {
            return call("put", basePath + path, data);
        },
        post: (path, data) => {
            return call("post", basePath + path, data);
        },
        delete: (path) => {
            return call("delete", basePath + path);
        },
    };
}

export function buildModelService(basePath) {
    const adminAPI = buildAdminAPI(basePath);
    return {
        api: adminAPI,
        fetchAll: () => {
            return adminAPI.get("");
        },
        fetchById: (id) => {
            return adminAPI.get(`/${id}`);
        },
        save: (model) => {
            if (model.id) {
                return adminAPI.put(`/${model.id}`, model);
            } else {
                return adminAPI.post(``, model);
            }
        },
        delete: (model) => {
            return adminAPI.delete(`/${model.id}`);
        },
    };
}
